import React, { SVGAttributes } from "react";
import styled, { css } from "styled-components";

export const OpenChevron = styled((props: SVGAttributes<SVGElement>) => (
  <svg
    {...props}
    xmlns="http://www.w3.org/2000/svg"
    width="28"
    height="28"
    viewBox="10 10 28 28"
  >
    <path d="M20 12l-2.83 2.83 9.17 9.17-9.17 9.17 2.83 2.83 12-12z" />
    <path d="M0 0h48v48h-48z" fill="none" />
  </svg>
))``;

const ExpandChevron = styled(
  ({
    open,
    black = false,
    ...props
  }: { open?: boolean; black?: boolean } & SVGAttributes<SVGElement>) => (
    <svg
      {...props}
      xmlns="http://www.w3.org/2000/svg"
      version="1.1"
      viewBox="0 0 100 43"
    >
      <rect width="60" height="10" x="2" y="29" />
      <rect height="10" width="60" y="29" x="38" />
    </svg>
  )
)`
  width: 1em;
  height: auto;

  & > rect {
    display: block;
    transform: rotate(0);
    transform-origin: center;
    transition: transform 0.2s ease;

    ${(props) =>
      css`
        fill: ${props.black ? "black" : `#1877ba`};
      `}
  }

  & > rect:first-child {
    transform: rotate(35deg);
  }

  & > rect:last-child {
    transform: rotate(-35deg);
  }

  ${(props) =>
    props.open &&
    css`
      & > rect:first-child {
        transform: translateX(-15px) translateY(-20.5px) rotate(-35deg);
      }

      & > rect:last-child {
        transform: translateX(14px) translateY(-20.5px) rotate(35deg);
      }
    `}
`;

export default ExpandChevron;
